import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=bdc69934&scoped=true&"
import script from "./AppInfo.vue?vue&type=script&lang=ts&"
export * from "./AppInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=bdc69934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc69934",
  null
  
)

export default component.exports